<template>
  <div>
    <h1>Access Denied</h1>
    <p>Sorry, you do not have access to that app. If you have received this <br/> message in error then please contact your system administrator.</p>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
}
</script>

<style scoped lang="less">
@import '../../less/elements/color.less';

div{
  padding-top: 1rem;
  text-align: left;
}
h1{
  font-size: 1.5rem;
  color: @color-border;
}
P {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/errors/accessForbidden.vue